<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Αναζήτηση"
                single-line
                clearable
                hide-details
              ></v-text-field>
            </v-col>
            <v-col >
               <v-select
                  :items=partCategories
                  label="Κατηγορία Ανταλλακτικού"
                  v-model="category"
                  :hint="`Cat-ID: ${category}`"
                  persistent-hint
                  :suffix="fi"
                  item-text="Description"
                  item-value="CatId"
                  clearable
                ></v-select>
            </v-col>
            <v-col>
              <v-combobox
                v-model="manf"
                :items="uniqueManufacturers"
                prepend-icon="mdi-factory"
                label="Κατασκευαστής"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(manf, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols=2>
               <v-switch
                  v-model="inStock"
                  label="Σε απόθεμα"
                ></v-switch>
            </v-col>
              </v-row>

        </v-card-text>
      </v-card>
    </template>

  <template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">Κέρδος Ανταλλακτικού</h1>
       <v-spacer/>
         <v-chip label>Κέρδος: {{ tocurr(sumField(parts, 'Profits')) }} ({{ partsProfitPcnt  }}%)</v-chip>
         <v-chip label>Τζιρος: {{ tocurr(partsSales) }}</v-chip>

    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="parts"
      loading: false
      :search="search"
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      single-expand: true
      :expanded.sync="expanded"
      show-group-by
      @current-items="updateSum"
      loading-text="Loading... Please wait"
    >
    <template v-slot:item.actions="{ item }">
         <v-btn
          icon
          small
          :to="{name: 'part-info', params: {id: item.PartId}}"
        >
         <v-icon>mdi-package-variant</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          :to="{name: 'edit-repair', params: {repairId: item.Repair}}"
        >
         <v-icon>mdi-car-wrench</v-icon>
        </v-btn>

     </template>
     <template
        v-slot:group.header="{ group, groupBy, items, isOpen, toggle, remove }"
      >
        <th colspan="10">
          <v-icon @click="toggle"
            >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
          </v-icon>
         <v-chip  v-if="groupBy=='CategoryId'" round color="primary">Κατηγορία: {{ partCategories.find(i => i.CatId === group).Description }}</v-chip> 
         <v-chip  v-else color="primary">{{ group }}</v-chip> 
          <v-chip round color="light-blue darken-4" text-color="white">Ποσότητα: {{ sumField(items, "Qty") }}</v-chip>
          <v-chip round color="light-blue darken-1" text-color="white">Κέρδος {{ tocurr(sumField(items, "Profits")) }}</v-chip>
          <v-icon @click="remove">mdi-close </v-icon>
        </th>
   </template>
   <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

                <div v-if="header.value == 'Profits'">
                    {{ tocurr(partsProfit) }}
                </div>
                <div class="text-right" v-if="header.value == 'Qty'">
                  {{ partsQty}}
                </div>
                <div class="text-right" v-if="header.value == 'Description'">
                  Σύνολο:
                </div>

                <div v-if="header.value == 'Cost'">
                    {{ tocurr(partsCost) }}
                </div>
                
                <div v-if="header.value == 'Price'">
                   {{ tocurr(partsSales) }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>
    <template v-slot:item.Sales="{ item }">
       {{ tocurr(item.Sales) }}
    </template>
    <template v-slot:item.Cost="{ item }">
       {{ tocurr(item.Cost) }}
    </template>
    <template v-slot:item.Price="{ item }">
       {{ tocurr(item.Price) }}
    </template>
    <template v-slot:item.Profits="{ item }">
       {{ tocurr(item.Profits) }}
    </template>
    <template v-slot:item.ProfitsPc="{ item }">
      {{ (item.ProfitsPc * 100) }}
    </template>
    <template v-slot:item.SuggestedPrice="{ item }">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >      {{ $tocurr(item.SuggestedPrice) }}</span>
      </template>
      <span>{{((item.SuggestedPrice/item.PartCost-1)*100).toFixed(0)}}% - {{$tocurr(item.SuggestedPrice-item.PartCost)}}</span>
    </v-tooltip>
    </template>
     <template v-slot:item.category_id="{ item }">
       {{ partCategories.find(i => i.CatId === item.CategoryId).Description }}
    </template>
    </v-data-table>
  </v-card>
</template>
  </v-container>
</template>

<script>

//import QuoteCard from '../../components/QuoteCard.vue';


export default {
  components: {
 //   QuoteCard
  },
  computed: {
      partsCost () {
        return this.parts.reduce((a, b) => a + (b.Qty*b.Cost|| 0), 0);
      },
      partsSales() {
        return this.parts.reduce((a, b) => a + (b.Qty*b.Price|| 0), 0);
      },
      partsProfit() {
        return this.parts.reduce((a, b) => a + (b.Profits|| 0), 0);
      },
      partsProfitPcnt() {
        return (100*this.parts.reduce((a, b) => a + (b.Profits|| 0), 0)/this.parts.reduce((a, b) => a + (b.Qty*b.Price|| 0), 0)).toFixed(2);
      },
      partsQty() {
        return this.parts.reduce((a, b) => a + (b.Qty|| 0), 0);
      },
      fi() {
        if (!this.category) return;
        return this.tocurr(this.sumField(this.filteredParts, 'Profits'))
      },
      isAdmin() {
          if (!this.$store.state.authentication.user) return false;
          return this.$store.state.authentication.user.scopes.includes("income");
      },
      uniqueManufacturers () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniq(this.parts, 'Manufacturer');
      },

  },
  data() {
    return {
      menu: false,
      expanded: [],
      checkoutdialog: false,
      partQty: 0,
      partTechId: 1,
      loading: true,
      newPart: {CategoryId: 0},
      partCategories: [],
      search: '',
      inStock: false,
      parts: [],
      filteredParts: [],
      manf: [],
      category: null,
      supplier: null,
      uniqueSuppliers: [],
      rules:  {
        partId: value => {
            const pattern = /^\d{1,5}$/
            return pattern.test(value) || 'Invalid Part-ID.'
          },
      },
      headers: [
            {
            text: 'Α/Α',
            align: 'start',
            //sortable: false,
            value: 'PartId',
            width: '5%',
          },
          {
            text: 'Κωδικός',
            align: 'start',
            //sortable: false,
            value: 'FmSku',
            width: '5%',
          },
          {
            text: 'Κωδικός Προμηθευτή',
            align: 'start',
            //sortable: false,
            value: 'SupplierSku',

            width: '5%',
          },
          { text: 'Κατηγορία', value: 'CategoryId', groupable: true, width: '15%',
          filter: (value) => {
            if (!this.category) return true;
            return value == this.category;
            },},
          { text: 'Περιγραφή', value: 'Description', groupable: false, width: '50%'},

         { text: 'Ποσότητα', value: 'Qty', align: 'end', groupable: false },
         { text: 'Κέρδος', value: 'Profits', align: 'end', groupable: false },
         //{ text: 'Κέρδος %', value: 'profits_pc', align: 'center', width: '10%', groupable: false },
          { text: 'Χρέωση', value: 'Price', align: 'end', groupable: false },
          { text: 'Αγορά', value: 'Cost', align: 'end', groupable: false },
          { text: 'Actions', value: 'actions', groupable: false, width: '25%' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get(`/inventory/customer/${this.$route.params.id}/sales`);
        // console.log(response);
        this.parts = response.data;
        const catresponse = await this.$api.get('/inventory/parts/categories');
        // console.log(response);
        this.partCategories = catresponse.data;
        //this.uniqueSuppliers = this.uniqSup(this.parts);
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  updateSum(e) {
      this.filteredParts = e
  },
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    
  uniqSup(items) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    let supp = null;
    for (let val of items) {
      //If item is already added then move to the next item
      supp = val["Invoice"]["Supplier"]
      if (itemsFound[supp.Id]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(supp);

      //Mark it as added
      itemsFound[supp.Id] = true;
    }

    //Return the uniques
    return uniques;
  },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.manf = [...obj];
  },
  }
}
</script>
